"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uint32Operators = exports.stringOperators = exports.TO_REGEXP = exports.SRC_REGEXP = exports.OUT_REGEXP = exports.IN_REGEXP = exports.FROM_REGEXP = exports.DST_REGEXP = void 0;
const stringOperators = exports.stringOperators = {
  '=': 'equals',
  '<>': 'does not equal',
  ILIKE: 'contains',
  'NOT ILIKE': 'does not contain'
};
const uint32Operators = exports.uint32Operators = {
  '=': 'equals',
  '<>': 'does not equal',
  '>': 'is greater than',
  '<': 'is less than'
};
const IN_REGEXP = exports.IN_REGEXP = new RegExp('_in(_|$)', 'gi');
const OUT_REGEXP = exports.OUT_REGEXP = new RegExp('_out(_|$)', 'gi');
const TO_REGEXP = exports.TO_REGEXP = new RegExp('_to(_|$)', 'gi');
const FROM_REGEXP = exports.FROM_REGEXP = new RegExp('_from(_|$)', 'gi');
const SRC_REGEXP = exports.SRC_REGEXP = new RegExp('_src(_|$)', 'gi');
const DST_REGEXP = exports.DST_REGEXP = new RegExp('_dst(_|$)', 'gi');